/** @format */
import styled, { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { MarketSelectorLinkProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const MarketSelectorLinkWrapper = styled.div`
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    column-gap: var(--layout-spacing-12);
    border-radius: 0.4rem;
    padding: var(--layout-spacing-8);
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: var(--colors-surface-secondary);
    }

    ${({ selected }: Omit<MarketSelectorLinkProps, 'market'>) => {
        if (!selected) return;

        /* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
        return css`
            border: 1px solid var(--colors-border-secondary);
            ${theme.typography.body_normal_highlight}
            cursor: default;

            &:hover {
                background-color: var(--colors-surface-primary);
            }
        `;
        /* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
    }}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const CheckmarkIconWrapper = styled.div`
    display: flex;

    .icon {
        font-size: 1.6rem;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
